var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 50,
    viewBox: "0 0 100 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7891 22.8086V44H8.00391V17.999H12.7891V22.5889C12.8216 21.9541 12.9681 21.36 13.2285 20.8066C13.4889 20.237 13.8307 19.7487 14.2539 19.3418C14.6934 18.9186 15.1979 18.5931 15.7676 18.3652C16.3372 18.1211 16.9476 17.999 17.5986 17.999H22.7012C23.3685 17.999 23.987 18.1292 24.5566 18.3896C25.1426 18.6338 25.6553 18.9756 26.0947 19.415C26.5342 19.8382 26.876 20.3428 27.1201 20.9287C27.3805 21.5146 27.5107 22.1413 27.5107 22.8086V27.2031H22.7012V22.8086H12.7891ZM41.9883 8.99023V44H36.9834V13.9951H30.9775V8.99023H41.9883ZM74.0195 44H69.21V22.8086H55.8066V44H51.0215V17.999H55.8066V22.5889C55.8392 21.9541 55.9857 21.36 56.2461 20.8066C56.5065 20.237 56.8483 19.7487 57.2715 19.3418C57.7109 18.9186 58.2155 18.5931 58.7852 18.3652C59.3548 18.1211 59.9652 17.999 60.6162 17.999H69.21C69.8773 17.999 70.5039 18.1292 71.0898 18.3896C71.6758 18.6338 72.1803 18.9756 72.6035 19.415C73.043 19.8382 73.3848 20.3428 73.6289 20.9287C73.8893 21.5146 74.0195 22.1413 74.0195 22.8086V44ZM90.5234 8.99023V44H85.5186V13.9951H79.5127V8.99023H90.5234Z",
    fill: "#E25822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmcc);
export default __webpack_public_path__ + "static/media/mmcc.fcf1bdf1f098e0335ffc9908f4fd22f3.svg";
export { ForwardRef as ReactComponent };